export default __webpack_public_path__ + "static/media/partner-the-killbox.c450d06f.png";